import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import type { BulkOfferResponse } from '@core/bulk-actions-types';
import { filterBoolean } from '@core/common-legacy';
import type {
  BulkManageEEOData,
  BulkSendEEOData,
  EEOCategories,
  EEOConfiguration,
  EEONoDataPlacements,
  EEOUpdateData,
  NoEEODataRequest,
} from '@core/eeo-types';
import { HttpApiService } from '@core/http-legacy';
import { getOptions } from '@core/walkthrough-util';

@Injectable({
  providedIn: 'root',
})
export class EEOHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public loadEEOConfiguration(): Observable<EEOConfiguration> {
    return this.httpApi.get('/eeo/settings').pipe(filterBoolean);
  }

  public updateEEOConfiguration(body: EEOUpdateData): Observable<EEOConfiguration> {
    return this.httpApi.patch('/eeo/settings', null, { companySettings: body }).pipe(filterBoolean);
  }

  public loadEEOCategories(): Observable<EEOCategories> {
    return this.httpApi.get('/eeo/job_categories', {}, { skipCompany: true }).pipe(filterBoolean);
  }

  public loadPlacementsWithoutEEOData(candidateId: number): Observable<EEONoDataPlacements> {
    return this.httpApi
      .get(`/eeo/candidate/${candidateId}`, null, getOptions({ hasOnboarding: true }))
      .pipe(filterBoolean);
  }

  public sendEmailForSingleCandidate(body: NoEEODataRequest): Observable<void> {
    return this.httpApi.post('/eeo/data_request', null, body).pipe(filterBoolean);
  }

  public bulkSend(body: BulkSendEEOData): Observable<void> {
    return this.httpApi.post('/eeo/bulk/data_request', null, body).pipe(filterBoolean);
  }

  public bulkResend(body: BulkSendEEOData): Observable<void> {
    return this.httpApi.post('/eeo/bulk/data_request/resend', null, body).pipe(filterBoolean);
  }

  public bulkManageEeo(body: BulkManageEEOData): Observable<BulkOfferResponse> {
    return this.httpApi.patch('/eeo/bulk/offers', null, body);
  }
}
